import React, { useState } from "react";
import "../Styles/Projects.css";
import { postersList } from "../utils/postersList";

const Posters = () => {
  const [selectedPoster, setSelectedPoster] = useState(null);

  const openModal = (logo) => setSelectedPoster(logo);
  const closeModal = () => setSelectedPoster(null);

  return (
    <div className="projects-page">
      <h1 style={{ textAlign: "center", fontFamily: "roboto", padding: "20px" }}>Our Client Posters</h1>
      <div className="projects-grid">
        {postersList.map((poster, index) => (
          <div key={index} className="project-card">
            <img src={poster.image} alt={poster.title} className="project-image" />
            <div className="project-details">
              <h2>{poster.title}</h2>
              <p>{poster.description}</p>
              <button className="project-link" onClick={() => openModal(poster)}>
                View Poster
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedPoster && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedPoster.image} alt={selectedPoster.title} className="modal-image" />
            <h2>{selectedPoster.title}</h2>
            <p>{selectedPoster.description}</p>
            <button onClick={closeModal} className="close-btn">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Posters;
